import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'gatsby'

import { Title, Button, Box, Text } from "../../components/Core";

const CTA = () => (
  <>
    {/* <!-- CTA section --> */}
    <Box className="position-relative" py={[4, null, null, 5, 6]}>
      <Container>
        <Row className="justify-content-center">
          <Col md="8" lg="9">
            <Box className="text-center">
              <Title textColor="dark">Create Your Smart Radio System</Title>
              <div className="d-flex flex-column align-items-center pt-3">
                <Link to="/contact">
                  <Button mb={2}>Contact Us</Button>
                </Link>
              </div>
            </Box>
          </Col>
        </Row>
      </Container>
    </Box>
  </>
);

export default CTA;
